<template>
  <div>
    <p class="cm-mg-p-wzd">1. {{ $t('common_words.general_information2') }}</p>
    <hr />
    <br />
    <div class="row">
      <div class="col-12 col-md-2">
        <fg-input
          type="text"
          :label="`${$t('common_words.code')}: *`"
          v-model="model.code"
          name="common_words.code"
          v-validate="modelValidations.code"
          :error="getError('common_words.code', true)"
          placeholder="..."
          @click="handleClickOnCode()"
        >
        </fg-input>
      </div>
      <div class="col-12 col-md-3">
        <fg-input
          type="text"
          :label="`${$t('common_words.crops')}: *`"
          v-model="model.name"
          name="common_words.crop"
          v-validate="modelValidations.cultivo"
          :error="getError('common_words.crops', true)"
          :placeholder="$t('common_words.banana')"
        ></fg-input>
      </div>
      <div class="col-12 col-md-2">
        <fg-input
          :precision="2"
          :step="0.01"
          :max="10"
          type="number"
          :label="`${$t('common_words.coefficient')}: `"
          v-model="model.coefficient"
          name="coeficiente"
          placeholder="1.1"
        ></fg-input>
      </div>
      <div class="col-12 col-md-5">
        <fg-input
          type="text"
          :label="`${$t('diseases.scientific_name')}:`"
          v-model="model.scientific_name"
          placeholder="..."
        ></fg-input>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col-12">
        <select-businesses-component
          :showLoading="true"
          @onChange="updateSelectedBusinesses"
          @showHideLoading="showHideLoading"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { isset } from 'src/util/Util';
import MixinForm from 'src/mixins/forms/mixin-form';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import store from '@/store';

export default {
  data() {
    return {
      model: {
        code: null,
        id: null,
        name: null,
        coefficient: null,
        businesses_id: [],
        businesses_names: [],
        scientific_name: '',
      },
      modelValidations: {
        cultivo: {
          required: true,
        },
        code: {
          required: true,
        },
      },
      businesses: null,
      marketers: null,
    };
  },
  mixins: [MixinPermissions, mixinMasters, MixinForm],
  methods: {
    handleClickOnCode() {
      const tableCodes = Object(
        JSON.parse(sessionStorage.getItem('tableCode'))
      );

      if (!isset(this.model.code) && !this.model.route) {
        this.codeGenerator('M Cultivos', tableCodes);
      }
    },

    updateSelectedBusinesses(data) {
      const bsSelected = data.associations_ids.concat(data.businesses_ids);
      this.$set(this.model, 'businesses_id', bsSelected);
      this.$set(this.model, 'businesses_names', data.names);
    },

    validate() {
      return this.$validator
        .validateAll()
        .then((res) => {
          this.$emit('on-validated', res, this.model);
          this.$emit('fillCropForm', 'firstStep', this.model);
          return res;
        })
        .then((resp) => {
          if (!resp) return resp;

          if (this.model.businesses_id.length == 0) {
            for (let index of document.getElementsByClassName('bus-rels')) {
              let sel = index.getElementsByClassName('el-input__inner')[0];
              sel.focus();
              sel.classList.add('custom-has-error');
              store.dispatch('utils/removeHasError', sel);
            }
            return false;
          } else return true;
        });
    },
  },

  mounted() {
    let editForm = {};
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model.id = editForm.id;
      this.model.name = editForm.name;
      this.model.coefficient = editForm.coefficient;
      this.model.code = editForm.code;
      this.model.scientific_name = editForm.scientific_name;
    }
  },
};
</script>
<style></style>
